export default __webpack_public_path__ + "8f0266346433e3a379f4e895d8b3a119.png";